import Image from "next/image";
import { BsTaxiFrontFill } from "react-icons/bs";
import { FaHotel, FaPassport } from "react-icons/fa6";
import { SiMealie } from "react-icons/si";

export const INCLUSION_ICONS = [
    { id: "flight", key: "isFlightIncluded", icon: <Image src={"/assets/icons/flightInclusion.svg"} alt="" height={16} width={16} /> },
    { id: "meal", key: "isMealsIncluded", icon: <SiMealie alt="" /> },
    { id: "transfer", key: "isTransferIncluded", icon: <BsTaxiFrontFill alt="" /> },
    { id: "hotel", key: "isHotelIncluded", icon: <FaHotel alt="" /> },
    { id: "visa", key: "isVisaIncluded", icon: <FaPassport alt="" /> },
    { id: "activity", key: "isActivityIncluded", icon: <Image src={"/assets/icons/activityInclusion.svg"} alt="" height={16} width={16} /> },
];